import React from 'react'
import FlexView from 'react-flexview/lib'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { Radio, FormControlLabel } from '@material-ui/core'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import { SpecialPricePopup } from '../../PopUps/SpecialPricePopup'
import brokerApi from '../../../api/broker.api'
import { SessionService } from '../../../services/SessionService'
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import { SessionContextStore } from '../../../context/SessionContext'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import { awaitWithLoading } from '../../../services/utils'


export const SpecialPriceSection = () => {

    const offersContext = React.useContext(BuyingInsuranceContextStore)
    const insuranceContext = React.useContext(InsurancePurchaseContextStore)
    const sessionContext = React.useContext(SessionContextStore)
    const isFirstRun = React.useRef(true);
    
    const onClickYes = () => {
        EventEmitterService.dispatch(EventKey.SHOW_SPECIAL_PRICE_POPUP)
    }


    React.useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

    }, [insuranceContext.selectedOption.liabilityLimit])

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.SPECIAL_POPUP_APPROVE, async (data) => {
            let customPremium = Math.abs(data.custom_premium)
            if(SessionService.isAdmin()) {
                offersContext.setLiabilitySpecialPrice(customPremium)
            }
        })

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.SPECIAL_POPUP_APPROVE, id)
        }
    }, [offersContext, insuranceContext, sessionContext])

    return <>
        <FlexView vAlignContent={'center'} className="space-between margin-top-basic">
            <FlexView vAlignContent={'center'}>
                <div className="text-body bold black">Special Price</div>
            </FlexView>
        </FlexView>
        
        <div className="text-body dark-grey margin-top-small">Is there a special price defined by {FirebaseService.getValue(FirebaseConfigKey.INSURANCE_COMPANY_NAME)}?</div>
        <FormControlLabel label={'Yes'} onChange={onClickYes} checked={offersContext.liabilitySpecialPrice.enabled == 'yes'} control={<Radio color={'primary'} />} />
        <FormControlLabel label={'No'} onChange={offersContext.flipLiabilitySpecialPrice} checked={offersContext.liabilitySpecialPrice.enabled == 'no'} control={<Radio color={'primary'} />} />

        
        {offersContext.liabilitySpecialPrice.enabled == 'yes' && offersContext.liabilitySpecialPrice.custom_premium > 0 && <FlexView className="margin-top-basic">
            <div className="text-body black">Selected special price: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{Number(offersContext.liabilitySpecialPrice.custom_premium).toLocaleString()}</div>
            <div onClick={onClickYes} className="text-body underline blue clickable margin-left-3">Change</div>
        </FlexView>}

        <SpecialPricePopup />
    </>
}